import React, { ReactNode } from 'react';

export type CardThemeType = 'light' | 'dark';

const Card = ({
  children,
  className,
  theme = 'dark',
}:{
  children: ReactNode;
  className?: string;
  theme?: CardThemeType;
}): JSX.Element => {
  const cardStyles = {
    background: (theme === 'light') ? 'white' : 'transparent',
    borderRadius: '6px',
    borderColor: (theme === 'light') ? 'black' : 'rgba(255,255,255,0.25)',
    borderWidth: '1px',
    borderStyle: 'solid',
    color: (theme === 'light') ? 'black' : 'white',
  };
  const _className = (className) ? `br-1 pa-4 ${className}` : 'br-1 pa-4';
  return (
    <div
      className={_className}
      style={{
        ...cardStyles,
      }}
    >
      {children}
    </div>
  );
};

export default Card;
